import React, { useState, useContext, useEffect } from "react";
import Select from "react-select";
import { FilterContext } from "../FilterContextProvider";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import Button from "../Components/Button";
import Input from "../Components/Input";
import ReportsLayout from "./ReportsLayout";
import useAllEvents from "../hooks/useAllEvents";
import { exportToCSV } from "../Utility/Csv";
import { Link } from "react-router-dom";
import useApi from "../Api/Api";
import { NotificationManager } from "react-notifications";
import Footer from "../Components/Footer";

const PaymentsDueVenue = () => {
  const { filterData } = useContext(FilterContext);
  const api = useApi();
  const [alterEventsObj, setAlterEventsObj] = useState({});
  const [errorMessage, setErrorMessage] = useState(false);
  const [chosenRow, setChosenRow] = useState();
  const [sortFilter, setSortFilter] = useState("date");

  const {
    allEvents,
    getAllEvents,
    setAllEventsSearch,
    setAllEventsSort,
    checkSentFilter,
    setCheckSentFilter,
    allEventDates,
    allEventDateOptions,
    handleAllEventDateSelect,
    renderCustomAllEventDateSelector,
  } = useAllEvents("show", "");

  const { renderFooter, splitItemsList, setCurrentPage } = Footer(
    allEvents.filter((each) => each.check_due_to_venue)
  );

  const sortOptions = [
    {
      label: "Date",
      value: "date",
    },
    {
      label: "City",
      value: "city",
    },
    {
      label: "State",
      value: "state",
    },
    {
      label: "Venue",
      value: "name",
    },
    {
      label: "Recently added",
      value: "created_at",
    },
  ];

  const sentOptions = [
    {
      label: "Yes",
      value: true,
    },
    {
      label: "No",
      value: false,
    },
    {
      label: "All",
      value: null,
    }
  ];

  const handleSentFilter = (e) => {
    if (e.value === true) {
      setCheckSentFilter(true);
    } else if (e.value === false) {
      setCheckSentFilter(false);
    } else {
      setCheckSentFilter(null);
    }
  };

  const handleDateRange = (e) => {
    setCurrentPage(1);
    handleAllEventDateSelect(e);
  };

  const handleSortSelect = (option) => {
    if (option.value !== sortFilter) {
      setCurrentPage(1);
      setSortFilter(option.value);
      setAllEventsSort(option.value);
    }
  };

  const [searchTimeout, setSearchTimeout] = useState();

  const handleSearchChange = (e) => {
    setCurrentPage(1);
    setSearchTimeout(e.target.value);
  };

  useEffect(() => {
    const delaySearch = setTimeout(() => {
      setAllEventsSearch(searchTimeout);
    }, 500);

    return () => clearTimeout(delaySearch);
  }, [searchTimeout, setAllEventsSearch]);

  const makeChosenRow = (product) => {
    setChosenRow(product.id);
  };

  const handleInputChange = ({ target: { name, value } }, eventToRender) => {
    setAlterEventsObj({
      ...alterEventsObj,
      [eventToRender.id]: {
        ...eventToRender,
        [name]: value,
      },
    });
  };

  const handleCheckChange = (e, eventToRender, state) => {
    setAlterEventsObj({
      ...alterEventsObj,
      [eventToRender.id]: {
        ...eventToRender,
        [e.target.id]: !state,
      },
    });
  };

  const revert = () => {
    const check = window.confirm(
      "Are you sure you want to revert? All unsaved changes will be lost."
    );
    if (check) {
      setAlterEventsObj({});
      setChosenRow();
    }
  };

  const handleUpdate = (event) => {
    event.preventDefault();
    setChosenRow();
    Promise.all(
      Object.values(alterEventsObj).map((event) => {
        if (!parseFloat(event.check_due_to_venue) > 0) {
          event.check_due_to_venue = 0;
        }
        return api.put(`/events/${event.id}`, { event });
      })
    )
      .then((response) => {
        NotificationManager.success(
          "Events successfully updated",
          "Success",
          2000
        );
        getAllEvents();
        setAlterEventsObj({});
        return response;
      })
      .catch((error) => {
        setErrorMessage(error.response.data);
      })
      .finally(() => {});
  };

  const showPayment = allEvents
    .filter((each) => each.check_due_to_venue)
    .map((event) => ({
      Event_Date: event.formattedDate,
      City: event.city,
      County: event.county,
      State: event.state,
      Gross_Sales: event.gross_sales,
      Check_due_to_Venue: event.check_due_to_venue,
      Sent: event.check_sent,
    }));

  const renderSelectArtistMessage = () => {
    return (
      <div className="m-8 py-12 pl-4">
        Please select an artist from the filter in order to see events
      </div>
    );
  };

  const renderEventsTable = () => {
    return (
      <div>
        <div>
          <div className="max-w-max">
            <Link to="/reports">
              <div className="-mt-6 mb-6 font-medium text-black text-sm">
                <FontAwesomeIcon icon={faArrowLeft}></FontAwesomeIcon> Back to
                reports
              </div>
            </Link>
          </div>
          <div className="text-xl mt-7 pb-8 font-medium">
            Payments Due Venue
          </div>
          <div className="-mt-5 mb-4 text-sm">
            <div className="flex">
              <div className="absolute mt-6 ml-2">
                <FontAwesomeIcon icon={faSearch}></FontAwesomeIcon>
              </div>
              <div className="w-1/4 text-xs">
                <Input
                  onChange={handleSearchChange}
                  value={searchTimeout}
                  placeholder="Search for events"
                  label="SEARCH"
                  bigPaddingLeft
                />
              </div>
              <div className="flex flex-col w-1/4 ml-2">
                <span className="text-xs">SORT BY</span>
                <Select
                  id="sort_filter"
                  className="text-xs font-light"
                  placeholder="Select sort by..."
                  options={sortOptions}
                  onChange={handleSortSelect}
                  value={sortOptions?.filter(
                    (each) => each.value === sortFilter
                  )}
                />
              </div>
              <div className="flex flex-col text-sm w-1/4 ml-2">
                <span className="text-xs">SELECT DATE RANGE</span>
                <Select
                  id="date"
                  className="text-xs font-light w-full"
                  placeholder="Select date range"
                  options={allEventDateOptions}
                  onChange={handleDateRange}
                  value={allEventDateOptions?.filter(
                    (each) => each.value === allEventDates.dateButton
                  )}
                />
              </div>
              <div className="flex flex-col text-sm w-1/4 ml-2">
                <span className="text-xs">Sent?</span>
                <Select
                  id="date"
                  className="text-xs font-light w-full"
                  placeholder="Filter by received"
                  options={sentOptions}
                  onChange={handleSentFilter}
                  value={sentOptions?.filter(
                    (each) => each.value === checkSentFilter
                  )}
                />
              </div>
            </div>
            <div className="my-4 w-1/2">
              {allEventDates.dateButton === "custom" &&
                renderCustomAllEventDateSelector()}
            </div>
          </div>
        </div>
        {splitItemsList.length > 0 ? (
          <div>
            <form>
              <table>
                <thead className="text-xs font-light">
                  <tr className="text-left border-b-2 h-11 w-full">
                    <td className="w-1/8">DATE</td>
                    <td className="w-1/5">CITY</td>
                    <td className="w-1/5">COUNTY</td>
                    <td className="w-thin">STATE</td>
                    <td className="w-1/8 text-right">GROSS SALES</td>
                    <td className="w-1/8 pl-4">CHECK OWED TO VENUE</td>
                    <td className="w-thin">SENT</td>
                  </tr>
                </thead>
                <tbody>
                  {splitItemsList.map((event, i) => {
                    const eventToRender = alterEventsObj[event.id] || event;
                    return (
                      <tr
                        key={eventToRender.id}
                        className={
                          alterEventsObj[eventToRender.id]
                            ? "bg-yellow-50 border-b text-sm h-11"
                            : "border-b text-sm h-11"
                        }
                      >
                        <td id={`date_${i}`}>{eventToRender.formattedDate}</td>
                        <td id={`city_${i}`}>{eventToRender?.city}</td>
                        <td id={`county_${i}`}>{eventToRender?.county}</td>
                        <td id={`state_${i}`}>{eventToRender?.state}</td>
                        <td id={`gross_sales_${i}`} className="text-right">
                          {eventToRender.gross_sales
                            ? eventToRender.gross_sales?.toLocaleString(
                                "en-US",
                                {
                                  style: "currency",
                                  currency: "USD",
                                }
                              )
                            : 0?.toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                              })}
                        </td>
                        <td className="px-2">
                          {chosenRow === eventToRender.id ? (
                            <Input
                              name="check_due_to_venue"
                              id={`check_due_to_venue_${i}`}
                              onChange={(e) =>
                                handleInputChange(e, eventToRender)
                              }
                              value={eventToRender.check_due_to_venue}
                              textRight
                            />
                          ) : (
                            <Input
                              name="check_due_to_venue"
                              id={`check_due_to_venue_${i}`}
                              onClick={() => makeChosenRow(eventToRender)}
                              onChange={() => makeChosenRow(eventToRender)}
                              value={parseFloat(
                                eventToRender.check_due_to_venue
                              )?.toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                              })}
                              textRight
                            />
                          )}
                        </td>
                        <td id={`check_sent_${i}`} className="text-center">
                          <input
                            className="mt-1"
                            type="checkbox"
                            id="check_sent"
                            checked={!!eventToRender?.check_sent}
                            onChange={(e) => {
                              handleCheckChange(
                                e,
                                eventToRender,
                                eventToRender.check_sent
                              );
                            }}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </form>
            {Object.keys(alterEventsObj).length !== 0 && (
              <span className="flex justify-center mt-4">
                <span className="mr-2">
                  <Button
                    className="button button-white"
                    onClick={revert}
                    text="Revert"
                  ></Button>
                </span>
                <Button
                  className="button"
                  onClick={handleUpdate}
                  text="Update"
                ></Button>
              </span>
            )}
          </div>
        ) : sortFilter ? (
          <div className="mx-12 py-16">
            No events match the provided filters
          </div>
        ) : (
          <div className="mx-12 py-16">
            No events have been added for this artist yet
          </div>
        )}
      </div>
    );
  };

  return (
    <ReportsLayout>
      <div>
        <div className="mt-8 mx-8 py-10 px-12 bg-white text-black rounded-lg border">
          {splitItemsList.length > 0 && (
            <div className="flex justify-end text-sm">
              <Button
                className="button"
                text="Export"
                onClick={() =>
                  exportToCSV(
                    showPayment,
                    `${filterData.artist_name}_payments_due_venue`
                  )
                }
              ></Button>
            </div>
          )}
          {filterData.artist_id
            ? renderEventsTable()
            : renderSelectArtistMessage()}
        </div>
        {splitItemsList.length > 0 && (
          <>
            <div className="grid justify-items-center">
              {errorMessage.error && (
                <div className="mt-4 text-red-500 pb-2">
                  {errorMessage.error}
                </div>
              )}
            </div>
            {renderFooter()}
          </>
        )}
      </div>
    </ReportsLayout>
  );
};

export default PaymentsDueVenue;
